module.exports = __webpack_public_path__ + "static/media/catalogue_ua_finwhale_2023_preview.0a023994.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/docs/catalogue_ua_finwhale_2023_preview.png
// module id = 729
// module chunks = 0